// Importing all created components
// import Sidebar from "../Sidebar/Sidebar";
// import Navbar from "../Navbar/Navbar";

import Footer from "../../components/footer";
import { StyledContainer } from "./style";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/header";
import { useEffect, useState } from "react";
import { Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HeaderBanner from "../../components/headerBanner";
import { MiniAppProvider } from "../../components/context";
import { Layout } from "..";
import { IPlayerGame } from "../../interfaces/interfaces";
import { ErrorBoundary } from "react-error-boundary";

// Pass the child props
export const BaseLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (localStorage.getItem("playerId") == null) {
      // TODO: add toast?
      navigate("/");
    }
  }, []);

  const [userName, setUserName] = useState<string>("");
  const [coins, setCoins] = useState<number>(0);
  const [level, setLevel] = useState<number>(0);
  const [perHour, setPerHour] = useState<number>(0);
  const [games, setGames] = useState<IPlayerGame[]>([]);

  return (
    <ErrorBoundary fallback={<div>Something went wrong :(</div>}>
      <MiniAppProvider
        context={{
          userName,
          setUserName,
          coins,
          setCoins,
          level,
          setLevel,
          perHour,
          setPerHour,
          games,
          setGames,
        }}
      >
        <Layout>
          {location.pathname.includes("referrals") ? (
            <HeaderBanner />
          ) : (
            <Header />
          )}
          <StyledContainer
            position="top-left"
            autoClose={800}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            stacked
            limit={20}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            transition={Bounce}
          />
          {/*  <Sidebar /> */}
          <Outlet />
          <Footer />
          {/*<Footer /> Attach if necessary */}
        </Layout>
      </MiniAppProvider>
    </ErrorBoundary>
  );
};
